import { each } from '@fxts/core';
import { $ } from 'rune-ts';

export const checkImageFormat = (changeSrc: (option: { url: string; format: string }) => string) => {
  const img_webp = new Image();
  const img_avif = new Image();

  const recur = () => {
    const img_src_els = document.querySelectorAll('img:not(.imageeee)');
    const bg_image_els = document.querySelectorAll('[style]:not(.imageeee)');

    each((img) => {
      const image = img as HTMLImageElement;
      $(img).addClass('imageeee');

      if (/\.webp|\.avif|f=webp|f=avif/gi.test(image.src)) {
        image.src = changeSrc({
          url: image.src,
          format: 'png',
        });
      }
    }, img_src_els);
    each((el) => {
      const html_el = el as HTMLElement;
      $(el).addClass('webppp');

      if (/\.webp|\.avif|f=webp|f=avif/gi.test(html_el.style.backgroundImage)) {
        html_el.style.backgroundImage = `url(${changeSrc({
          url: html_el.style.backgroundImage.slice(4, -1).replace(/"/g, ''),
          format: 'png',
        })})`;
      }
    }, bg_image_els);
    setTimeout(recur, 1000);
  };

  img_webp.onerror = recur;
  img_avif.onerror = recur;

  img_webp.src =
    'https://image1.marpple.co/files/u_1485274/2021/10/original/84e685b1b47bde000e9b9effcae22872f22082d31.png?f=webp&w=1&q=1';

  img_avif.src =
    'https://image1.marpple.co/files/u_1485274/2021/10/original/84e685b1b47bde000e9b9effcae22872f22082d31.png?f=avif&w=1&q=1';
};
